// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"6ac8c96b","453":"b463a5e2"}[chunkId] + ".chunk.js";
};